import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';

import { MatButtonModule } from '@angular/material/button';
import { MatListModule } from '@angular/material/list';
import { MatTree, MatTreeModule } from '@angular/material/tree';
import { RouterModule } from '@angular/router';
import { TagTreeComponent } from 'src/app/components/tag-tree/tag-tree.component';
import { PeriodService } from 'src/app/services/period.service';
import { TagNode } from 'src/services/tag-tree/TagNode';
import { DetailedTag } from 'src/services/tag/DetailedTag';
import { Period, Tag } from 'src/services/tag/Tag';
import { UserService } from 'src/services/user/user.service';
import { TagNodeIconComponent } from '../tag-node-icon/tag-node-icon.component';
import { TagNodeSummaryComponent } from '../tag-node-summary/tag-node-summary.component';

/**
 * @title Tree with nested nodes
 */
@Component({
  selector: 'sidebar',
  templateUrl: 'sidebar.component.html',
  styleUrls: ['sidebar.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    MatTreeModule,
    MatButtonModule,
    MatIconModule,
    MatListModule,
    MatDividerModule,
    TagNodeIconComponent,
    TagNodeSummaryComponent,
    TagTreeComponent,
  ],
  animations: [
    trigger('slideVertical', [
      state(
        '*',
        style({
          height: 0,
        })
      ),
      state(
        'show',
        style({
          height: '*',
        })
      ),
      transition('* => *', [animate('400ms cubic-bezier(0.25, 0.8, 0.25, 1)')]),
    ]),
  ],
})
export class SidebarComponent implements AfterViewInit {
  nonPeriodicTagNodes: TagNode[] = [];
  periodicTagNodes: TagNode[] = [];

  @Input()
  public set tagNodes(value: TagNode[]) {
    this.nonPeriodicTagNodes = value.filter((v) => !v.isPeriodic);
    this.periodicTagNodes = value.filter((v) => v.isPeriodic);
  }

  public get tagNodes() {
    return this._tagNodes;
  }

  private _tagNodes: TagNode[] = [];

  @Input() tag: string = '';
  @Input() detailedTags: DetailedTag[] = [];

  @Output() onAllEntriesClick = new EventEmitter<void>();
  @Output() onOpenPlannerClick = new EventEmitter<void>();
  @Output() onOpenSettingsClick = new EventEmitter<void>();
  @Output() onTagClick = new EventEmitter<{
    tag: Tag;
    period?: Period;
    preventSidebarClose?: boolean;
  }>();

  @ViewChild('myMatTree') tree: MatTree<TagNode> | null = null;
  @ViewChild('periodicTagTree')
  periodicTagTreeComponent!: ElementRef<TagTreeComponent>;

  constructor(
    public matDialog: MatDialog,
    public userService: UserService,
    public periodService: PeriodService
  ) {
    this.periodService.periodSubject.subscribe((_val) => {
      if (this.periodicTagTreeComponent) {
        // @ts-ignore
        this.periodicTagTreeComponent.hardRefresh();
      }
    });
  }
  ngAfterViewInit(): void {}

  openPlannerDialog() {
    this.onOpenPlannerClick.emit();
  }

  openSettingsDialog() {
    this.onOpenSettingsClick.emit();
  }

  public hardRefresh() {
    // TODO: hard refresh all trees
  }

  nextPeriodClick() {
    this.periodService.next();
    this.emitCurrentTagWithPeriod(true);
  }

  previousPeriodClick() {
    this.periodService.previous();
    this.emitCurrentTagWithPeriod(true);
  }

  emitCurrentTagWithPeriod(preventSidebarClose: boolean) {
    if (this.tag) {
      const currentTag: DetailedTag | undefined = this.detailedTags.find(
        (t) => t.fullPath === this.tag
      );
      if (currentTag) {
        this.onTagClick.emit({
          tag: currentTag,
          period: this.periodService.current,
          preventSidebarClose,
        });
      }
    }
  }
}
